export const IS_CART_OPEN = "cart_isOpen";

export function getEffectiveSubscriptionDiscountPercent(
  percent: number,
  options?: { isBulk?: boolean; isBundle?: boolean }
): number {
  if (options?.isBulk || options?.isBundle) {
    return percent;
  }

  return percent;
}

/**
 * Gets the free shipping bundle product IDs from the global metafield.
 * Returns empty array if metafield is empty or not set (no free shipping).
 *
 * @param metafields - Optional array of global metafields
 * @returns Array of product IDs for free shipping bundle, or empty array if no free shipping
 */
export function getFreeShippingBundleProductIds(metafields?: any[]): number[] {
  // If no metafields provided, return empty array (no free shipping)
  if (!metafields || !Array.isArray(metafields)) {
    return [];
  }

  // Filter out null/undefined values and find the target metafield
  const validMetafields = metafields.filter((mf) => mf != null);
  const metafield = validMetafields.find(
    (mf) =>
      mf.namespace === "custom" && mf.key === "free_shipping_bundle_product_ids"
  );

  // If metafield not found or value is empty, return empty array (no free shipping)
  if (!metafield?.value || metafield.value.trim() === "") {
    return [];
  }

  try {
    const parsedValue = JSON.parse(metafield.value);

    // If parsed value is not an array or is empty, return empty array
    if (!Array.isArray(parsedValue) || parsedValue.length === 0) {
      return [];
    }

    return parsedValue;
  } catch (error) {
    console.error("Failed to parse free shipping bundle product IDs:", error);
    // If parsing fails, return empty array (no free shipping)
    return [];
  }
}
